import get from "lodash/get";
import includes from "lodash/includes";
import { LOGIN, LOGOUT, USER_DETAILS,PERMISSIONS } from "../../constants/actionTypes.js";
import { axiosAuthInstance } from "../../utilities/configureAuthAxios.js";
import { axiosReportInstance } from "../../utilities/configureReportAxios";
import {
  SUPER_ADMIN_ROLE_ID,
  COMPANY_ADMIN_ROLE_ID,
  COMPANY_ADMIN_REPORT_ROLE_ID,
} from "../../constants";

const initialState = {
  user: null,
  token: null,
  isLoggedIn: false,
  isSuperAdmin: false,
  isCompanyAdmin: false,
  isStaff: false,
  permissions:undefined
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        token: get(action, "payload.token"),
        isLoggedIn: true,
      };

    case USER_DETAILS:
      return {
        ...state,
        user: {
          name: get(action, "payload.name"),
          imageUrl: get(action, "payload.imageUrl"),
          email: get(action, "payload.email"),
          role: get(action, "payload.role"),
          timeZone: get(action, "payload.timeZoneIdVO"),
          version: get(action, "payload.version"),
        },
        isSuperAdmin:
          get(action, "payload.role.id") === SUPER_ADMIN_ROLE_ID ? true : false,
        isCompanyAdmin:
          get(action, "payload.role.id") === COMPANY_ADMIN_ROLE_ID ||
          includes(COMPANY_ADMIN_REPORT_ROLE_ID, get(action, "payload.role.id"))
            ? true
            : false,
        isStaff:
          get(action, "payload.role.id") !== SUPER_ADMIN_ROLE_ID &&
          get(action, "payload.role.id") !== COMPANY_ADMIN_ROLE_ID &&
          !includes(
            COMPANY_ADMIN_REPORT_ROLE_ID,
            get(action, "payload.role.id")
          )
            ? true
            : false,
        rootUser: get(action, "payload.rootUser"),
        organizationName: get(action, "payload.organizationName"),
        organizationType: get(action, "payload.organizationType"),
        organizationId: get(action, "payload.organizationId"),
        authorities: get(action, "payload.authorities"),
        userId: get(action, "payload.id"),
      };
   case PERMISSIONS:
  return {
    ...state,
    permissions: get(action,"payload.permissions")
  }
    case LOGOUT: {
      return {
        ...state,
        user: null,
        token: null,
        isLoggedIn: false,
        role: null,
      };
    }

    case "persist/REHYDRATE":
      if (get(action.payload, "auth.token", null)) {
        axiosAuthInstance.defaults.headers.common.authorization = `Bearer ${get(
          action.payload,
          "auth.token",
          null
        )}`;
        axiosReportInstance.defaults.headers.common.authorization = `Bearer ${get(
          action.payload,
          "auth.token",
          null
        )}`;
      }

      return state;

    default:
      return state;
  }
};

export default authReducer;
